/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/

import { services, metadata } from '@broadleaf/admin-components';

import AuroraOrderView from 'app/oms/components/AuroraOrderView';
import AuroraOverflowColumn from 'app/oms/components/AuroraOrderView/components/AuroraOverflowColumn';
import AuroraErrorColumn from 'app/oms/components/AuroraOrderView/components/AuroraErrorColumn';
import AuroraBrowseErrorColumn from 'app/oms/components/AuroraOrderView/components/AuroraBrowseErrorColumn';
import AuroraOrderTotals from './components/AuroraOrderSummaryView/components/AuroraOrderTotals';
import AuroraFulfillmentCardItem from './components/ItemsOrderViewSection/components/FulfillmentCard/components/FulfillmentCardItem/FulfillmentCardItem';
import AuroraFulfillmentCardHeader from './components/ItemsOrderViewSection/components/FulfillmentCard/components/FulfillmentCardHeader/FulfillmentCardHeader';
import AuroraFulfillmentCardStatusIndicator from 'app/oms/components/ItemsOrderViewSection/components/FulfillmentCard/components/FulfillmentCardStatusIndicator/FulfillmentCardStatusIndicator';
import AuroraFulfillmentViewDetailsStatusIndicator from 'app/oms/components/FulfillmentView/components/FulfillmentViewDetailsStatusIndicator/FulfillmentViewDetailsStatusIndicator';
import { AuroraFulfillmentCardStatusChangeModal } from 'app/oms/components/ItemsOrderViewSection/components/FulfillmentCard/action-components/FulfillmentCardStatusChange';
import { FulfillmentCardCreateReturn } from 'app/oms/components/FulfillmentCard/action-components/FulfillmentCardCreateReturn';

const { ComponentRegistrar } = services;
const { ItemsOrderViewSection } = metadata.views;

ComponentRegistrar.registerViewComponent(AuroraOrderView.TYPE, AuroraOrderView);
ComponentRegistrar.registerColumnComponent(
  AuroraOverflowColumn.TYPE,
  AuroraOverflowColumn
);
ComponentRegistrar.registerColumnComponent(
  AuroraErrorColumn.TYPE,
  AuroraErrorColumn
);
ComponentRegistrar.registerColumnComponent(
  AuroraBrowseErrorColumn.TYPE,
  AuroraBrowseErrorColumn
);
ComponentRegistrar.registerViewComponent(
  AuroraOrderTotals.TYPE,
  AuroraOrderTotals
);

const customItemsOrderViewComponents = {
  components: {
    FulfillmentCardItem: AuroraFulfillmentCardItem,
    FulfillmentCardHeader: AuroraFulfillmentCardHeader
  }
};
ComponentRegistrar.registerViewComponent('ORDER_ITEMS', props =>
  ItemsOrderViewSection({ ...props, ...customItemsOrderViewComponents })
);

ComponentRegistrar.registerComponent(
  'blFulfillmentViewDetailsStatusIndicator',
  AuroraFulfillmentViewDetailsStatusIndicator
);
ComponentRegistrar.registerComponent(
  'blFulfillmentCardStatusIndicator',
  AuroraFulfillmentCardStatusIndicator
);
ComponentRegistrar.registerComponent(
  'blFulfillmentCardStatusChangeModal',
  AuroraFulfillmentCardStatusChangeModal
);
ComponentRegistrar.registerComponent(
  'blFulfillmentCardCreateReturn',
  FulfillmentCardCreateReturn
);
